import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BearScoreAction, NoteAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-bear-score-slot',
    templateUrl: './bear-score-slot.component.html',
    styleUrl: './bear-score-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BearScoreSlotComponent implements SheetSlotComponentBase {

	action!: BearScoreAction;
	value!: string | null;

	@Input('action') set updateAction(action: BearScoreAction | null) {
		this.action = action as BearScoreAction;
		this.value = this.action.totalScore?.toString() ?? null;
	}

	constructor() {
	}
}